export default __webpack_public_path__ + "static/media/logo_clarks.ee83b406.png";